var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5V13.65C0 15.3897 3.29071 16.8 7.35 16.8C8.61697 16.8 9.80907 16.6626 10.8496 16.4207C13.1429 15.8876 10.8496 16.4 10.8496 16.4V13.2707C9.80907 13.5126 8.61697 13.65 7.35 13.65C3.29071 13.65 0 12.2397 0 10.5Z",
    fill: "#CCCDD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.25V8.4C0 10.1397 3.29071 11.55 7.35 11.55C8.61697 11.55 10.8496 11.1707 10.8496 11.1707V8.0207C10.8496 8.0207 8.61697 8.4 7.35 8.4C3.29071 8.4 0 6.9897 0 5.25Z",
    fill: "#CCCDD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 3.15C14.7 4.8897 11.4093 6.3 7.35 6.3C3.29071 6.3 0 4.8897 0 3.15C0 1.4103 3.29071 0 7.35 0C11.4093 0 14.7 1.4103 14.7 3.15Z",
    fill: "#CCCDD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3999 13.1V15.65C11.3999 17.0583 14.0638 18.2 17.3499 18.2C20.636 18.2 23.2999 17.0583 23.2999 15.65V13.1C23.2999 14.5083 20.636 15.65 17.3499 15.65C14.0638 15.65 11.3999 14.5083 11.3999 13.1Z",
    fill: "#CCCDD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3999 8.85V11.4C11.3999 12.8083 14.0638 13.95 17.3499 13.95C20.636 13.95 23.2999 12.8083 23.2999 11.4V8.85C23.2999 10.2583 20.636 11.4 17.3499 11.4C14.0638 11.4 11.3999 10.2583 11.3999 8.85Z",
    fill: "#CCCDD4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2999 7.15C23.2999 8.55832 20.636 9.7 17.3499 9.7C14.0638 9.7 11.3999 8.55832 11.3999 7.15C11.3999 5.74167 14.0638 4.6 17.3499 4.6C20.636 4.6 23.2999 5.74167 23.2999 7.15Z",
    fill: "#CCCDD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRate);
export default __webpack_public_path__ + "static/media/rate.9b8e4606.svg";
export { ForwardRef as ReactComponent };